import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";
import Modal from "../components/common/CommonModal";

function VoucherNumberSettingsTab() {
    const COMPANY_CODE = localStorage.getItem("companyCode") || "-";

  const [isCommonMode, setIsCommonMode] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingVoucher, setEditingVoucher] = useState(null);
  const [nextNumber, setNextNumber] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState(
    localStorage.getItem("currentSelectedDepartment") || "MAIN",
  );

  const {
    data: voucherList,
    loading: loadingList,
    get: fetchVoucherList,
  } = useApi();
  const {
    data: commonList,
    loading: loadingCommon,
    get: fetchCommonList,
  } = useApi();
  const { data: saveResponse, post: saveVoucher } = useApi();
  const { data: departmentList, get: fetchDepartments } = useApi();

  const baseUrl = "https://cubixweberp.com:213/api/CRMVoucherSettings";

  // Fetch department list on mount
  useEffect(() => {
    fetchDepartments(
      `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/DEPTLIST/-/-`,
    );
  }, []);

  // Fetch voucher list when department, mode, or search changes
  useEffect(() => {
    const mode = isCommonMode ? "COMMON" : selectedDepartment;
    const search = searchText || "-";
    fetchVoucherList(
      `${baseUrl}/${COMPANY_CODE}/VOUCHERNUMBERS/${mode}/ALL/-/${search}`,
    );
  }, [isCommonMode, selectedDepartment, searchText]);

  // Handle save response
  useEffect(() => {
    if (saveResponse?.result?.trim()?.toUpperCase() === "SAVED") {
      alert("Updated successfully!");
      setIsModalOpen(false);
      setEditingVoucher(null);
      // Refresh list
      const mode = isCommonMode ? "COMMON" : selectedDepartment;
      const search = searchText || "-";
      fetchVoucherList(
        `${baseUrl}/${COMPANY_CODE}/VOUCHERNUMBERS/${mode}/ALL/-/${search}`,
      );
    }
  }, [saveResponse]);

  const handleEdit = (voucher) => {
    setEditingVoucher(voucher);
    setNextNumber(voucher.NEXT_NO);
    setIsModalOpen(true);
  };

  const handleUpdate = () => {
    if (!editingVoucher || !nextNumber) return;

    const payload = isCommonMode
      ? (currentList || []).map((item) => ({
          CmpCode: COMPANY_CODE,
          mod: "M",
          vrtype: item["V.TYPE"],
          vrdesc: item["V.DESCRIPTION"],
          deptno: item.DEPTNO,
          next_vno: nextNumber,
          categ: item.CATEGORY,
          appLevel: item.Approval_Level,
          appEmail: item.Approval_emails,
        }))
      : [
          {
            CmpCode: COMPANY_CODE,
            mod: "M",
            vrtype: editingVoucher["V.TYPE"],
            vrdesc: editingVoucher["V.DESCRIPTION"],
            deptno: selectedDepartment,
            next_vno: nextNumber,
            categ: editingVoucher.CATEGORY,
            appLevel: editingVoucher.Approval_Level,
            appEmail: editingVoucher.Approval_emails,
          },
        ];

    saveVoucher(
      "https://cubixweberp.com:213/api/CRMvouchersettingsReg",
      JSON.stringify(payload),
      { headers: { "Content-Type": "application/json" } },
    );
  };

  const handleDepartmentChange = (e) => {
    const newDept = e.target.value;
    setSelectedDepartment(newDept);
    // localStorage.setItem("currentSelectedDepartment", newDept);
  };

  const currentList = isCommonMode ? commonList : voucherList;
  const isLoading = isCommonMode ? loadingCommon : loadingList;

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Voucher Number Settings
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            {isCommonMode ? "Common Mode" : `Department: ${selectedDepartment}`}
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => setIsCommonMode(!isCommonMode)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${
              isCommonMode
                ? "bg-blue-600 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={
                  isCommonMode
                    ? "M5 13l4 4L19 7"
                    : "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                }
              />
            </svg>
            Common Number
          </button>

          <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors">
            Transfer Master
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="mb-4 flex gap-4">
        {/* Department Dropdown */}
        {!isCommonMode && (
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Department
            </label>
            <div className="relative">
              <select
                value={selectedDepartment}
                onChange={handleDepartmentChange}
                className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white"
              >
                {departmentList?.map((dept) => (
                  <option key={dept.deptno} value={dept.deptno}>
                    {dept.deptno} - {dept.deptnodesc}
                  </option>
                ))}
              </select>
              <svg
                className="w-5 h-5 text-gray-400 absolute right-3 top-2.5 pointer-events-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        )}

        {/* Search */}
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Search
          </label>
          <div className="relative">
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search vouchers..."
              className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <svg
              className="w-5 h-5 text-gray-400 absolute left-3 top-2.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div
          className="overflow-x-auto"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Department
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Description
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Next No
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {isLoading ? (
                <tr>
                  <td
                    colSpan="6"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    Loading...
                  </td>
                </tr>
              ) : !currentList || currentList.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    No vouchers found
                  </td>
                </tr>
              ) : (
                currentList.map((item, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {item.CATEGORY}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {item.DEPTNO}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {item["V.TYPE"]}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {item["V.DESCRIPTION"]}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {item.NEXT_NO}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <button
                        onClick={() => handleEdit(item)}
                        className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 font-medium"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Edit Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditingVoucher(null);
        }}
        title="Edit Voucher Number"
      >
        {editingVoucher && (
          <div className="space-y-4 p-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Type
              </label>
              <p className="text-gray-900">{editingVoucher["V.TYPE"]}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <p className="text-gray-900">{editingVoucher["V.DESCRIPTION"]}</p>
            </div>

            {isCommonMode && (
              <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                <p className="text-sm text-yellow-800">
                  ⚠️ This will update all vouchers in common mode
                </p>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Next Number
              </label>
              <input
                type="number"
                value={nextNumber}
                onChange={(e) => setNextNumber(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter next number"
              />
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  setEditingVoucher(null);
                }}
                className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdate}
                disabled={!nextNumber || nextNumber === editingVoucher.NEXT_NO}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                Update
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default VoucherNumberSettingsTab;
